import { render } from "./MandatesTable.vue?vue&type=template&id=bf07e31e&scoped=true"
import script from "./MandatesTable.vue?vue&type=script&lang=js"
export * from "./MandatesTable.vue?vue&type=script&lang=js"

import "./MandatesTable.vue?vue&type=style&index=0&id=bf07e31e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf07e31e"]])

export default __exports__